import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { CmsFormPanel, PanelContent, PanelHeader, PanelTitle, PanelTrigger } from '@/components/shared/CmsFormPanel';
import { Plus } from 'lucide-react';
import { ConfirmDialog } from '@/components/shared';
import type { Post, PostFormData } from './postsmanager.props';

interface PostsFormDialogProps {
  isDialogOpen: boolean;
  setIsDialogOpen: (open: boolean) => void;
  editingPost: Post | null;
  setEditingPost: (post: Post | null) => void;
  formData: PostFormData;
  setFormData: (data: PostFormData) => void;
  handleSubmit: (e: React.FormEvent) => void;
  deleteTarget: any;
  setDeleteTarget: (target: any) => void;
  confirmDelete: () => void;
}

const PostsFormDialog: React.FC<PostsFormDialogProps> = ({
  isDialogOpen, setIsDialogOpen, editingPost, setEditingPost,
  formData, setFormData, handleSubmit, deleteTarget, setDeleteTarget, confirmDelete,
}) => (
  <>
    <CmsFormPanel open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <PanelTrigger asChild>
        <Button onClick={() => setEditingPost(null)}>
          <Plus className="w-4 h-4 mr-2" />
          Додај пост
        </Button>
      </PanelTrigger>
      <PanelContent>
        <PanelHeader>
          <PanelTitle>{editingPost ? 'Измени пост' : 'Додај нов пост'}</PanelTitle>
        </PanelHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="title">Наслов *</Label>
            <Input
              id="title"
              value={formData.title}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              required
            />
          </div>
          <div>
            <Label htmlFor="excerpt">Извадок *</Label>
            <Textarea
              id="excerpt"
              value={formData.excerpt}
              onChange={(e) => setFormData({ ...formData, excerpt: e.target.value })}
              rows={2}
              required
            />
          </div>
          <div>
            <Label htmlFor="content">Содржина *</Label>
            <Textarea
              id="content"
              value={formData.content}
              onChange={(e) => setFormData({ ...formData, content: e.target.value })}
              rows={6}
              required
            />
          </div>
          <div>
            <Label htmlFor="image">URL на слика *</Label>
            <Input
              id="image"
              value={formData.image}
              onChange={(e) => setFormData({ ...formData, image: e.target.value })}
              placeholder="https://example.com/image.jpg"
              required
            />
          </div>
          <div className="flex justify-end space-x-2 pt-4">
            <Button type="button" variant="outline" onClick={() => setIsDialogOpen(false)}>Откажи</Button>
            <Button type="submit">{editingPost ? 'Зачувај промени' : 'Објави пост'}</Button>
          </div>
        </form>
      </PanelContent>
    </CmsFormPanel>
    <ConfirmDialog
      open={deleteTarget !== null}
      onOpenChange={(open) => !open && setDeleteTarget(null)}
      title="Избриши пост"
      description="Дали сте сигурни дека сакате да го избришете овој пост?"
      onConfirm={confirmDelete}
    />
  </>
);

export default PostsFormDialog;
